import { createSelector } from "@reduxjs/toolkit";
import { IActivityHistoryFilter, IActivityHistoryUpFilter, isUpFilter } from "../model";
import { activityHistoryFiltersSelector } from "../selectors";

export const upFilterSelector = createSelector(activityHistoryFiltersSelector, (filters: IActivityHistoryFilter[]) =>
  filters.find(isUpFilter),
);

export const upFilterEnabledValuesSelector = createSelector(
  upFilterSelector,
  (filter: IActivityHistoryUpFilter) => filter?.enabledValues || [],
);

export const areUpFiltersActive = createSelector(upFilterEnabledValuesSelector, (filters) => !!filters.length);
